import script from "./UpgradeComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./UpgradeComponent.vue?vue&type=script&setup=true&lang=js"

import "./UpgradeComponent.vue?vue&type=style&index=0&id=6307a19c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\killi\\WebstormProjects\\chess_vuejs\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6307a19c"]])

export default __exports__